import { useNavigate, useParams, useSearchParams } from 'react-router-dom';

import { Page } from '@/components/layout/Page';
import { ErrorState } from '@/components/ui/EmptyState';
import { Spinner } from '@/components/ui/Spinner';
import { useCandidate } from '@/features/candidates/api';

import { useMeeting } from '../api';
import { MeetingForm } from '../components/MeetingForm';

export function MeetingEditorPage() {
  const { id } = useParams();
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const candidateId = params.get('candidate') ?? '';
  const meeting = useMeeting(id);
  const candidate = useCandidate(id ? '' : candidateId);
  const fromCandidate = candidateId && (!id || meeting.data?.candidate.id === candidateId);
  const backTo = fromCandidate ? `/candidates/${candidateId}` : '/meetings/calendar';
  const close = () => {
    void navigate(backTo, { replace: true });
  };
  if ((id && meeting.isPending) || (!id && candidateId && candidate.isPending)) {
    return (
      <Page>
        <Spinner label="Loading meeting details" />
      </Page>
    );
  }
  if (meeting.isError || candidate.isError) {
    return (
      <Page>
        <ErrorState
          message="The meeting details could not be loaded."
          onRetry={() => {
            if (id) void meeting.refetch();
            else void candidate.refetch();
          }}
        />
      </Page>
    );
  }
  const at = new Date(params.get('at') ?? '');
  return (
    <MeetingForm
      key={id ?? candidateId}
      meeting={meeting.data ?? null}
      candidateId={candidate.data?.id}
      candidateName={candidate.data?.full_name}
      initialDate={Number.isFinite(at.getTime()) ? at : undefined}
      backTo={backTo}
      onClose={close}
    />
  );
}
